import { RootState } from 'handlers';

export const getAuthData = ({ auth }: RootState) => auth;
